export default {
  objects: [

  ],
  background: '',
};
